module.exports = __webpack_public_path__ + "media/images/question_examples/question-example-open-text-4cd1a3dc5013fe4d83291868f762e8ef.png";